import React from 'react';

import { AuthHistoryTable } from './components/table/AuthHistoryTable';
import TwoFactorAuthenticationSection from './components/TwoFactorAuthenticationSection';
import { useStateSelector } from '../../data/global/dataSelectors';

/**
 * 2FA controls and sign-in history are stacked full-width. Side-by-side layout used too much
 * horizontal space for the wide login history grid; separate Security sub-tabs would split related
 * content and add navigation cost when the top-level account tabs already include Security.
 */
export const AccountSecurity: React.FunctionComponent<{}> = () => {
  const twoFactorAuthenticationState = useStateSelector(
    s => s.account.profile.current && s.account.profile.current.twoFactorAuthenticationState
  );

  return (
    <div className="container-fluid account-management-security-scoped" style={{ height: '100%', minWidth: 0 }}>
      <div className="row">
        {twoFactorAuthenticationState && (
          <div className="col-12 mb-4">
            <TwoFactorAuthenticationSection />
          </div>
        )}
        <div className="col-12">
          <AuthHistoryTable />
        </div>
      </div>
    </div>
  );
};
